import type { SportsToday } from '../account/api';

/**
 * The last match list, kept so Home shows it at once on the next visit
 * while a fresh one loads (the list call can take seconds).
 */
const STORAGE_KEY = 'viva.sportsToday';
/** Older than this, the list is too stale to show (finished matches, old channel tests). */
export const SPORTS_CACHE_MAX_AGE_MS = 60 * 60 * 1000;

interface Saved {
  account: string;
  at: number;
  data: SportsToday;
}

function storage(): Storage | undefined {
  try {
    return typeof localStorage === 'undefined' ? undefined : localStorage;
  } catch {
    return undefined;
  }
}

/** The saved list for this account, when recent enough. */
export function readSportsCache(account: string, now = Date.now()): SportsToday | null {
  try {
    const saved = JSON.parse(storage()?.getItem(STORAGE_KEY) ?? 'null') as Saved | null;
    if (!saved || saved.account !== account || !saved.data || !Array.isArray(saved.data.matches)) return null;
    return now - saved.at >= 0 && now - saved.at < SPORTS_CACHE_MAX_AGE_MS ? saved.data : null;
  } catch {
    return null;
  }
}

export function saveSportsCache(account: string, data: SportsToday, now = Date.now()): void {
  try {
    storage()?.setItem(STORAGE_KEY, JSON.stringify({ account, at: now, data } satisfies Saved));
  } catch {
    // Full or blocked storage: the next visit just waits for the list.
  }
}
